import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export interface TableCellBackgroundOptions {
  HTMLAttributes: Record<string, string>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    tableCellBackground: {
      setTableCellBackground: (color: string) => ReturnType;
      unsetTableCellBackground: () => ReturnType;
    };
  }
}

export const TableCellBackground = Extension.create<TableCellBackgroundOptions>({
  name: 'tableCellBackground',

  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },

  addCommands() {
    return {
      setTableCellBackground:
        (color: string) =>
        ({ commands }) => {
          return commands.updateAttributes('tableCell', {
            style: `background-color: ${color}`
          });
        },
      unsetTableCellBackground:
        () =>
        ({ commands }) => {
          return commands.updateAttributes('tableCell', {
            style: ''
          });
        }
    };
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('tableCellBackground'),
        props: {
          decorations: (state) => {
            const { doc } = state;
            const decorations: Decoration[] = [];

            doc.descendants((node, pos) => {
              if (node.type.name === 'tableCell' && node.attrs.style) {
                const style = node.attrs.style;
                const backgroundColorMatch = style.match(/background-color:\s*([^;]+)/);

                if (backgroundColorMatch) {
                  const color = backgroundColorMatch[1];
                  decorations.push(
                    Decoration.node(pos, pos + node.nodeSize, {
                      style: `background-color: ${color}`
                    })
                  );
                }
              }
            });

            return DecorationSet.create(doc, decorations);
          }
        }
      })
    ];
  }
});
